import React from 'react';

import DatePickerTag4 from '@/components/common/DatePicker/DatePickerTag4';
import styles from './contract-input.module.scss';

interface IContractDatepickerHeaderItemProps {
  id?: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  onChange: ({ value }: { value: Date | null }) => void;
  value?: Date;
  errorMessage?: any;
}

export default function ContractDatepickerHeaderItem({
  id,
  label,
  placeholder,
  required = false,
  onChange,
  value,
  errorMessage,
}: IContractDatepickerHeaderItemProps) {
  return (
        <div>
            <div className={styles['ag-contract-input']}>
                <label className={styles.label} htmlFor={id}>
                    {`${label} `}
                    {required && <span>*</span>}
                </label>
                <div className={styles.wrapper}>
                    <DatePickerTag4
                        id={id}
                        onChange={onChange}
                        placeholder={placeholder}
                        value={value}
                    />
                    {errorMessage && (
                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                            {errorMessage}
                        </div>
                    )}
                </div>
            </div>
        </div>
  );
}
